import type { AppThunk } from '@store/migrationActions/thunkActions/types'
import { metaActions } from '@store/reducers/manager/meta/actions'

import API from '@/api'

export const changeAvatar =
  ({
    customAvatar,
    customAvatarFilename,
    projectId,
  }: {
    customAvatar: string | null
    customAvatarFilename: string | null
    projectId: string
  }): AppThunk =>
  (dispatch) => {
    API.Avatar.update({
      avatar: customAvatarFilename,
      projectId,
    })
      .then(() => {
        dispatch(metaActions.updateAvatar({ avatar: customAvatar }))
      })
      .catch(console.error)
  }
